// define __esModule on exports
__w_pdfjs_require__.r = (exports) => {
	if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
	}
	Object.defineProperty(exports, '__esModule', { value: true });
};


// WEBPACK FOOTER //
// webpack://pdfjs-dist/build/pdf.worker/webpack/runtime/make namespace object